/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas-prebuilt (ignored)
// module id = 39
// module chunks = 0